export enum PropertyMediaVideoActionTypes {
  SET_MEDIA_VIDEO_LIST = '[MEDIA VIDEOS] Set list',
  SAVE_MEDIA_VIDEOS = '[MEDIA VIDEOS] Save videos',
  DELETE_VIDEO = '[MEDIA VIDEOS] Delete video',
  UPDATE_POSITION = '[MEDIA VIDEOS] Update video position',
  CLEAR_HIGHLIGHTED = '[MEDIA VIDEOS] Clear highlight videoId',
};
